import React from "react";
import { AlertTriangle, X } from "lucide-react";

const BlockAccountModal = ({
  isOpen,
  onClose,
  onConfirm,
  isBlocking,
  businessName,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Overlay */}
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      {/* Modal */}
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-500">
            <X className="h-5 w-5" />
          </button>

          <div className="sm:flex sm:items-start">
            {/* Icon */}
            <div
              className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10 ${
                isBlocking ? "bg-red-100" : "bg-green-100"
              }`}>
              <AlertTriangle
                className={`h-6 w-6 ${
                  isBlocking ? "text-red-600" : "text-green-600"
                }`}
              />
            </div>

            {/* Content */}
            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                {isBlocking ? "Block Account" : "Unblock Account"}
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  {isBlocking ? (
                    <>
                      Are you sure you want to block{" "}
                      <span className="font-medium text-gray-900">
                        {businessName}
                      </span>
                      ? This action will prevent them from:
                      <ul className="mt-2 list-disc pl-5 space-y-1">
                        <li>Placing new orders</li>
                        <li>Accessing their account</li>
                        <li>Using existing vouchers</li>
                      </ul>
                    </>
                  ) : (
                    <>
                      Are you sure you want to unblock{" "}
                      <span className="font-medium text-gray-900">
                        {businessName}
                      </span>
                      ? This will restore their full access to:
                      <ul className="mt-2 list-disc pl-5 space-y-1">
                        <li>Place new orders</li>
                        <li>Access their account</li>
                        <li>Use existing vouchers</li>
                      </ul>
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-3">
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className={`inline-flex w-full justify-center rounded-lg px-3 py-2 text-sm font-semibold text-white shadow-sm sm:w-auto ${
                isBlocking
                  ? "bg-red-600 hover:bg-red-500"
                  : "bg-green-600 hover:bg-green-500"
              } ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}>
              {isLoading ? (
                <div className="flex items-center">
                  <div className="h-4 w-4 mr-2 rounded-full border-2 border-white border-t-transparent animate-spin" />
                  Processing...
                </div>
              ) : isBlocking ? (
                "Block Account"
              ) : (
                "Unblock Account"
              )}
            </button>
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="mt-3 inline-flex w-full justify-center rounded-lg bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockAccountModal;
